// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPartialUserItem,
}                               from '../interfaces';

const getUser = async ({
    test,
    userId,
}: {
    test: boolean,
    userId: string,
}): Promise<IPartialUserItem | null> => {
    const functions = getFunctions();
    const handleGetUser = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        IPartialUserItem | null
    >(
        functions,
        'getUser',
    );
    return handleGetUser({
        test,
        userId,
    }).then((result) => {
        const partialUser = result.data as IPartialUserItem | null;
        return partialUser;
    }).catch((err) => {
        throw err;
    });
};

export default getUser;
